import type { InstallationIds } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { X } from "lucide-react";

interface InstallationIdsFilterProps {
  value: InstallationIds;
  onChange: (value: InstallationIds) => void;
}

export function InstallationIdsFilter({ value, onChange }: InstallationIdsFilterProps) {
  const addId = () => {
    onChange({ ...value, installation_ids: [...value.installation_ids, ""] });
  };

  const updateId = (index: number, id: string) => {
    const next = [...value.installation_ids];
    next[index] = id;
    onChange({ ...value, installation_ids: next });
  };

  const removeId = (index: number) => {
    onChange({
      ...value,
      installation_ids: value.installation_ids.filter((_, i) => i !== index),
    });
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>Installation IDs</Label>
        <Button type="button" variant="outline" size="sm" onClick={addId}>
          Add ID
        </Button>
      </div>
      {value.installation_ids.map((id, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            value={id}
            onChange={(e) => updateId(i, e.target.value)}
            placeholder="installation_id"
            className="flex-1"
          />
          <Button type="button" variant="ghost" size="icon" onClick={() => removeId(i)}>
            <X className="h-4 w-4 text-red" />
          </Button>
        </div>
      ))}
    </div>
  );
}
